import React, {Component} from "react";
import {Card, ListGroup} from "react-bootstrap";
import "../Elements/FromGroup/form_select.css"
import AscModal from "../Elements/Modal/Modal";

export default class PartnerDeleteModal extends Component {

    render() {
        let nameList = Array.isArray(this.props.state.name)
            ? this.props.state.name
            : [this.props.state.name];
        let idList = Array.isArray(this.props.state.hm12_id)
            ? this.props.state.hm12_id
            : [this.props.state.hm12_id];

        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                modalClose={this.props.modalClose}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                onClick={this.props.onClick}
            >
                <Card variant="info">
                    <Card.Header>
                        <Card.Title>
                            {this.props.langText.Body.PartnerInfo}
                        </Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <p>{this.props.langText.Body.PartnerDeleteConfirm}</p>
                        <ListGroup>
                            {nameList.map((name, idx) => (
                                <ListGroup.Item key={idList[idx] != null ? idList[idx] : idx}>{name}</ListGroup.Item>
                            ))}
                        </ListGroup>
                        <p className="text-danger mt-2">
                            {this.props.langText.Body.PartnerDeleteWarning}
                        </p>
                    </Card.Body>
                </Card>
            </AscModal>
        );
    }
}

